import React from "react"
import { scaleLinear } from "d3-scale"
import PropTypes from "prop-types"

const GRADIENT = [
  [0, "#F5A623"], // 0% utilization is orange
  [0.2, "#F5A623"], // 20% utilization is the same orange
  [0.6, "#8CE2CD"], // 60% utilization is light blue
  [0.85, "#00BF90"], // 85% utilization is green
  [1, "#EA465C"], // 100% utilization is red
]

export const generateGradientFn = maxInEntityCount => {
  return scaleLinear()
    .domain(GRADIENT.map(g => maxInEntityCount * g[0]))
    .range(GRADIENT.map(g => g[1]))
}

// This generates the subset of our full gradient that will get used in the graph.
// We do not want to use our full gradient unless the peak usage points
// fully span from the bottom to the top of the graph.
const Gradient = ({ gradientFn, minAssetsUsed, maxAssetsUsed, gradientID }) => {
  const stops = scaleLinear()
    .domain([minAssetsUsed, maxAssetsUsed])
    .range([0, 100])

  return (
    <linearGradient id={gradientID} x1="0%" y1="100%" x2="0%" y2="0%">
      {stops
        .ticks(100) // arbitrarily high number to ensure smooth gradient subset
        .map(i => (
          <stop key={i} offset={`${stops(i)}%`} stopColor={gradientFn(i)} />
        ))}
    </linearGradient>
  )
}

Gradient.propTypes = {
  gradientFn: PropTypes.func,
  minAssetsUsed: PropTypes.number,
  maxAssetsUsed: PropTypes.number,
  gradientID: PropTypes.string,
}

export default Gradient
